const STORAGE_KEY_PREFIX = 'initial_assessment_flow_started_at:'

const storageKey = (residentId: string) => `${STORAGE_KEY_PREFIX}${residentId}`

const readStartedAt = (residentId: string): number | null => {
  if (!residentId) {
    return null
  }
  try {
    const raw = sessionStorage.getItem(storageKey(residentId))
    if (!raw) {
      return null
    }
    const parsed = Number.parseInt(raw, 10)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

/** Records flow start when an in-progress assessment is detected (does not overwrite). */
export const ensureInitialAssessmentFlowStartedAt = (
  residentId: string
): void => {
  if (!residentId || readStartedAt(residentId) != null) {
    return
  }
  startInitialAssessmentFlow(residentId)
}

/** Records flow start when the user explicitly starts a new initial assessment. */
export const startInitialAssessmentFlow = (residentId: string): void => {
  if (!residentId) {
    return
  }
  try {
    sessionStorage.setItem(storageKey(residentId), String(Date.now()))
  } catch {
    // sessionStorage may be unavailable
  }
}

export const clearInitialAssessmentFlowStartedAt = (
  residentId: string
): void => {
  if (!residentId) {
    return
  }
  try {
    sessionStorage.removeItem(storageKey(residentId))
  } catch {
    // sessionStorage may be unavailable
  }
}

export const getInitialAssessmentFlowDurationMs = (
  residentId: string
): number | null => {
  const startedAt = readStartedAt(residentId)
  if (startedAt == null) {
    return null
  }
  return Math.max(0, Math.round(Date.now() - startedAt))
}
